import { Typography } from 'antd';
import styled from 'styled-components';

import { RedColors } from '@/theme';

export const StyledText = styled(Typography.Text)`
  color: ${RedColors[60]};
  font-weight: bold;
`;
